import { useSeriesCardContext } from './series-card'
import React from 'react'
import { Badge } from 'src/component/ui/badge/badge'
import { cn } from 'src/lib/utils'
import { stringUtil } from 'src/util/string-util'

/** Active / in-progress cards: season + week only (progress row covers class count). */
interface SeriesCardMetaActiveProps {
  className?: string
}

export const SeriesCardMetaActive = ({ className }: SeriesCardMetaActiveProps): React.ReactElement => {
  const { series } = useSeriesCardContext()

  const seasons = series.duration?.seasons || 0
  const weeks = series.duration?.weeks || 0

  return (
    <div className={cn('mt-2 flex flex-row gap-3', className)}>
      {seasons > 0 && (
        <Badge>
          {stringUtil.pluralizeIfNeeded({
            itemCount: seasons,
            singular: 'season',
          })}
        </Badge>
      )}
      {weeks > 0 && (
        <Badge>
          {stringUtil.pluralizeIfNeeded({
            itemCount: weeks,
            singular: 'week',
          })}
        </Badge>
      )}
    </div>
  )
}
